export default function groupItems(array:any[], property:string):Object {
    return array.reduce(function (groups, item) {
      var name = item[property];
      var group = groups[name] || (groups[name] = []);
      group.push(item);
      return groups;
    }, {});
  }